define('app/models/tracker',['app/setup'], function(takhfifan) {

  takhfifan.Tracker = Backbone.Model.extend({

    initialize: function() {
      if (typeof ga === 'undefined' || _.isNull(ga)) {
        window.ga = [];
      }

      var _this = this;

      takhfifan.eventHub.on(
        'newsletter:subscribe',
        _this.trackSubscription,
        _this
      );

      takhfifan.eventHub.on(
        'customer:registered',
        _this.trackRegistration,
        _this
      );

      takhfifan.eventHub.on(
        'headernewsletter:subscribe',
        _this.trackHeaderSubscription,
        _this
      );

      takhfifan.eventHub.on(
        'footernewsletter:subscribe',
        _this.trackFooterSubscription,
        _this
      );

      takhfifan.eventHub.on(
        'popupnewsletter:subscribe',
        _this.trackPopupSubscription,
        _this
      );

      takhfifan.eventHub.on(
        'muglanding:subscribe',
        _this.trackMugSubscription,
        _this
      );

      takhfifan.eventHub.on(
        'fulldiscount:subscribe',
        _this.trackFullDiscountSubscription,
        _this
      );

      takhfifan.eventHub.on(
        'fulldiscount:scrolldown',
        _this.trackFullDiscountScrollDown,
        _this
      );

      takhfifan.eventHub.on(
        'specialDiscount:click',
        _this.trackSpecialDiscount,
        _this
      );
      takhfifan.eventHub.on(
        'dc:getDiscount',
        function (options) {
          _this.trackGetDiscount(options);
        },
        _this
      );
      takhfifan.eventHub.on(
        'dc:goToPartnerWebSite',
        function (options) {
          _this.trackDcGoToPartnerWebSite(options);
        },
        _this
      );
      takhfifan.eventHub.on(
        'dc:copyCode',
        function (options) {
          _this.trackDcCopyCode(options);
        },
        _this
      );
      takhfifan.eventHub.on(
        'offline_form:error',
        function (options) {
          _this.trackOfflineFormError('offline_request-error', options);
        },
        _this
      );
      takhfifan.eventHub.on(
        'offline_passenger:error',
        function (options) {
          _this.trackOfflineFormError('offline_passenger-error', options);
        },
        _this
      );

      takhfifan.eventHub.on(
        'success_bank_card:submit',
        function (options) {
          _this.trackSuccessAddBankCard();
        },
        _this
      );
    },

    trackSubscription: function(data) {
      ga('send','event', 'newsletter', 'subscribe');
    },

    trackRegistration: function(data) {
      ga('send', 'event','customer', 'register');
    },

    trackHeaderSubscription: function(data) {
      ga('send', 'event','headernewsletter', 'subscribe');
    },

    trackFooterSubscription: function(data) {
      ga('send', 'event','footernewsletter', 'subscribe');
    },

    trackPopupSubscription: function(data) {
      ga('send', 'event','popupnewsletter', 'subscribe');
    },

    trackMugSubscription: function(data) {
      ga('send', 'event','muglanding', 'subscribe');
    },

    trackFullDiscountSubscription: function(data) {
      ga('send', 'event', 'fulldiscount', 'subscribe');
    },

    trackFullDiscountScrollDown: function(data) {
      ga('send', 'event', 'fulldiscountscrolldown', 'subscribe');
    },

    trackSpecialDiscount: function(data) {
      ga('send', 'event', 'specialDiscount', 'click');
    },

    trackGetDiscount: function(data) {
      ga('send', 'event', 'getDiscount', 'click', data.productID);
      ga('send', 'event', 'getDiscount', 'click', data.vendorId);
    },

    trackDcGoToPartnerWebSite: function(data) {
      ga('send', 'event', 'discountGoToPartnerWebSite', 'click' , data.productID);
      ga('send', 'event', 'discountGoToPartnerWebSite', 'click' , data.vendorId);
    },
    trackDcCopyCode: function(data) {
      ga('send', 'event', 'discountCopyCode', 'click' , data.productID);
      ga('send', 'event', 'discountCopyCode', 'click' , data.vendorId);
    },
    trackOfflineFormError: function(action, data) {
      ga('send', 'event', 'offlineForm', action , data);
    },
    trackSuccessAddBankCard: function() {
      ga('send', 'event', 'successAddBankCard', 'submit');
    },

  });

});

